var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('div',{attrs:{"id":"header_wrap"}},[_c('div',{attrs:{"id":"admin_wrap"}},[_c('div',{staticClass:"logo_area"},[_c('logo')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }